import Papa from "papaparse";
import _ from "lodash";
import validateOrderCsv from "./validateOrder";
import moment from "moment";
import { cleanObject } from "./cleanObject";

const parseOrders = (orderFile, orderParams) => {
  const { clientId, homebaseIds, teamIds } = orderParams;

  let currentRow = 0;
  let orderFileData = [];
  const validationErrors = [];

  return new Promise((resolve, reject) => {
    if (_.isEmpty(clientId)) {
      return reject({ message: "ClientId Not Found!" });
    }
    if (_.isEmpty(homebaseIds)) {
      return reject({ message: "HomebaseIds Not Found!" });
    }
    if (_.isEmpty(teamIds)) {
      return reject({ message: "TeamIds Not Found!" });
    }

    Papa.parse(orderFile, {
      header: true,
      escapeChar: '"',
      skipEmptyLines: true,
      error: () => {
        return reject({ message: "File Processing Failed!" });
      },
      step: ({ data }) => {
        const row = {
          orderId: data["Order ID"],
          teamId: data["Team ID"],
          type: data["Type"],
          orderDate: data["Order Date"],
          homebaseId: data["Homebase ID"],
          locationId: data["Location ID"],
          scContainerCase: data["SCONTAINER-CASE"],
          skuId: data["Sku ID"],
          skuCase: data["Case"],
          skuLineItemId: data["Sku Line Item ID"],
          skuDetail: data["Sku Detail"],
          volume: data["Volume"],
          volumeUnit: data["Volume Unit"],
          quantity: data["Quantity"],
          quantityUnit: data["Quantity Unit"],
          fullcase: data["CUS:FULLCASE"],
          kbox: data["CUS:KBOX"],
          tote: data["CUS:TOTE"],
          pop: data["CUS:POP"],
          totalCase: data["CUS:TOTAL-CASE"],
        };
        //removing row object keys with empty values
        const validRowData = _.omitBy(row, (value) => value === "");
        const { error, value } = validateOrderCsv(
          validRowData,
          homebaseIds,
          teamIds
        );
        if (error) {
          const errorMessage = error.details
            .map((details) => details.message.replace(/['"]+/g, ""))
            .join(", ");
          validationErrors.push(`Row-${currentRow + 1}: ${errorMessage}`);
        } else {
          orderFileData.push(value);
        }
        currentRow += 1;
      },
      complete: () => {
        if (!_.isEmpty(validationErrors)) {
          return reject({
            message: "Found Errors in CSV File!",
            data: validationErrors,
          });
        }

        //removing duplicate order file data
        const uniqueOrderFileData = _.uniqWith(orderFileData, _.isEqual);
        const orders = [];
        for (const item of uniqueOrderFileData) {
          let order = {
            id: item.orderId,
            teamId: item.teamId,
            type: item.type,
            orderDate: item?.orderDate?.length
              ? moment(item.orderDate, "DD/MM/YYYY").format("YYYY-MM-DD")
              : "",
            homebaseId: item.homebaseId,
            locationId: item?.locationId,
            lineItems: [
              {
                id: item.skuId,
                lineItemId: item.skuLineItemId,
                name: item.skuDetail,
                quantity: item.quantity,
                quantityUnit: item.quantityUnit,
                parts: [
                  {
                    volume: {
                      value: item.volume,
                      unit: item.volumeUnit,
                    },
                  },
                ],
              },
            ],
            customProperties: {
              FULLCASE: item.fullcase,
              KBOX: item.kbox,
              TOTE: item.tote,
              POP: item.pop,
              "TOTAL-CASE": item.totalCase,
            },
          };
          order = cleanObject(order);
          orders.push(order);
        }
        return resolve({
          message: "",
          data: orders,
        });
      },
    });
  });
};

export default parseOrders;
